import { render, staticRenderFns } from "./OpenAssemblies.vue?vue&type=template&id=357d9dea"
import script from "./OpenAssemblies.vue?vue&type=script&lang=js"
export * from "./OpenAssemblies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports